export default "__VITE_ASSET__01edZ$cA__"